__turbopack_context__.v({
  "body": "DUGTBW_body",
  "mainColumn": "DUGTBW_mainColumn",
  "page": "DUGTBW_page",
});
